/* fiveaven (23/10/2026, Andy : « sur la description, avocat etc., faut mettre systématiquement la description pour le bon
   type, et pas tout d'un coup ») : quand la description d'une fiche contient un paragraphe par déclinaison (« <strong>Avocat</strong>
   <br>… », « <strong>Citron</strong><br>… », ou un intertitre par déclinaison), seul celui de la déclinaison choisie reste
   affiché ; il change avec la pastille cliquée. L'introduction et tout ce qui ne correspond à aucune déclinaison restent.
   Correspondance souple : casse, accents et parenthèses ignorés, puis premier mot (« Aloe » = « Aloe Vera »,
   « Kelp (algues marines) » = « Kelp (algue marine) »). Moins de 2 correspondances : la description n'est pas touchée. */
(function () {
  var norm = function (s) {
    return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\(.*?\)/g, " ")
      .replace(/[^a-z0-9]+/g, " ").trim();
  };
  var mot1 = function (s) { return norm(s).split(" ")[0] || ""; };

  // groupes d'options de la fiche : { nom, valeurs[], choisie }
  function options() {
    var g = {};
    document.querySelectorAll('input[type="radio"][name]').forEach(function (r) {
      if (!r.closest("fieldset.product-form__input")) return;
      var o = g[r.name] || (g[r.name] = { nom: r.name, valeurs: [], choisie: null });
      if (o.valeurs.indexOf(r.value) < 0) o.valeurs.push(r.value);
      if (r.checked) o.choisie = r.value;
    });
    document.querySelectorAll("select.product-form__input[name]").forEach(function (s) {
      var o = g[s.name] || (g[s.name] = { nom: s.name, valeurs: [], choisie: s.value });
      [].forEach.call(s.options, function (op) { if (o.valeurs.indexOf(op.value) < 0) o.valeurs.push(op.value); });
    });
    return Object.keys(g).map(function (k) { return g[k]; });
  }

  // blocs « par déclinaison » d'une description : paragraphe ouvert par un <strong>, ou intertitre h3/h4/h5 et sa suite
  function blocs(rte) {
    var out = [], enfants = [].slice.call(rte.children);
    enfants.forEach(function (el, i) {
      var titre = null, membres = [el];
      if (el.tagName === "P") {
        var premier = el.firstElementChild, avant = premier ? el.innerHTML.split("<" + premier.tagName.toLowerCase())[0] : "x";
        if (premier && /^(STRONG|B)$/.test(premier.tagName) && !avant.replace(/&nbsp;|\s/g, "")) titre = premier.textContent;
      } else if (/^H[3-5]$/.test(el.tagName)) {
        titre = el.textContent;
        for (var j = i + 1; j < enfants.length && !/^H[1-5]$/.test(enfants[j].tagName); j++) membres.push(enfants[j]);
      }
      if (titre && norm(titre).length && norm(titre).length < 40) out.push({ titre: titre, membres: membres });
    });
    return out;
  }

  function correspond(titre, valeur) {
    var t = norm(titre), v = norm(valeur);
    return t === v || (mot1(t).length > 2 && mot1(t) === mot1(v));
  }

  function appliquer() {
    var opts = options(); if (!opts.length) return;
    document.querySelectorAll(".rte").forEach(function (rte) {
      if (rte.closest("[data-fv-faq], .fv-faq, details")) return;
      var bs = blocs(rte); if (bs.length < 2) return;
      // l'option dont les valeurs correspondent au plus grand nombre de blocs
      var meilleure = null, n = 0;
      opts.forEach(function (o) {
        var k = bs.filter(function (b) { return o.valeurs.some(function (v) { return correspond(b.titre, v); }); }).length;
        if (k > n) { n = k; meilleure = o; }
      });
      if (!meilleure || n < 2 || !meilleure.choisie) return;
      var visible = bs.some(function (b) { return correspond(b.titre, meilleure.choisie); });
      bs.forEach(function (b) {
        var lie = meilleure.valeurs.some(function (v) { return correspond(b.titre, v); });
        var montrer = !lie || !visible || correspond(b.titre, meilleure.choisie);
        b.membres.forEach(function (m) { m.style.display = montrer ? "" : "none"; });
      });
      rte.setAttribute("data-fv-declinaison", meilleure.choisie);
    });
  }

  var minuteur = null;
  var plusTard = function () { clearTimeout(minuteur); minuteur = setTimeout(appliquer, 60); };
  document.addEventListener("change", function (e) {
    if (e.target && e.target.closest && e.target.closest("fieldset.product-form__input, select.product-form__input")) plusTard();
  });
  // le thème réécrit des morceaux de fiche au changement de déclinaison : on réapplique après chaque réécriture
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { plusTard(); return; }
  }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", appliquer); else appliquer();
})();
